import { formatHeatmapSlotRange } from '@/components/HeatmapGridCell';
import { utcOffsetHours } from '@/lib/timezoneOffsetLabel';

export const CONTENT_HOUR_SLOTS = [
  { label: '12 AM', startHour: 0 },
  { label: '2 AM', startHour: 2 },
  { label: '4 AM', startHour: 4 },
  { label: '6 AM', startHour: 6 },
  { label: '8 AM', startHour: 8 },
  { label: '10 AM', startHour: 10 },
  { label: '12 PM', startHour: 12 },
  { label: '2 PM', startHour: 14 },
  { label: '4 PM', startHour: 16 },
  { label: '6 PM', startHour: 18 },
  { label: '8 PM', startHour: 20 },
  { label: '10 PM', startHour: 22 },
] as const;

export const CONTENT_HOUR_SLOT_HEADERS = CONTENT_HOUR_SLOTS.map((slot) =>
  formatHeatmapSlotRange(slot.startHour),
);

/** Fold 24 hourly counts into the 12 two-hour slots used by the other heatmaps. */
export function slotCountsFromHours(hourCounts: number[] | undefined): number[] {
  const hours = Array.from({ length: 24 }, (_, hour) => Number(hourCounts?.[hour] ?? 0) || 0);
  return CONTENT_HOUR_SLOTS.map((_, slot) => hours[slot * 2]! + hours[slot * 2 + 1]!);
}

function windowMidpoint(startDate?: string, endDate?: string): Date {
  if (startDate && endDate) {
    const start = Date.parse(startDate);
    const end = Date.parse(endDate);
    if (Number.isFinite(start) && Number.isFinite(end)) {
      return new Date((start + end) / 2);
    }
  }
  return new Date();
}

/**
 * Rotate API UTC hour buckets into the selected IANA zone.
 * Uses the offset at the window midpoint (DST at "now" when bounds are missing).
 * Half-hour offsets round to the nearest hour.
 */
export function hourCountsInTimezone(
  utcHourCounts: number[] | undefined,
  timeZone: string,
  startDate?: string,
  endDate?: string,
): number[] {
  const utc = Array.from({ length: 24 }, (_, hour) => Number(utcHourCounts?.[hour] ?? 0) || 0);
  const shift = Math.round(utcOffsetHours(timeZone, windowMidpoint(startDate, endDate)));
  if (shift % 24 === 0) return utc;
  const local = Array.from({ length: 24 }, () => 0);
  for (let hour = 0; hour < 24; hour++) {
    local[((hour + shift) % 24 + 24) % 24]! += utc[hour]!;
  }
  return local;
}
